import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useContext } from "react";
import ProfileDataCardTitle from "ProfileComponents/common/ProfileDataCardTitle/ProfileDataCardTitle";
import styles from "./style.module.css";
import ProfileBasicsDataCardItem from "../../MyProfile/BasicsComponent/ProfileBasicsDataCardItem";
import ChangePasswordBox from "./ChangePasswordBox";
import AccountContext from "../context";
import RoundedGainfulButton from "../../common/RoundedGainfulButton";
import { useAppStore } from "Root/profile/lib/store";
const AccountDetails = () => {
    const { editMode, updateEditModeState, userAccount, onChangeData } = useContext(AccountContext);
    const [changePassword, setChangePassword] = useState(false);
    const { subscriberData, setSubscriberData } = useAppStore();
    const onChange = (value, name) => {
        onChangeData(value, name);
        setSubscriberData({
            ...subscriberData,
            [name]: value,
        });
    };
    function getPhoneNumber(number) {
        if (number === undefined) {
            return "";
        }
        const numbers = number.match(/\d/g);
        if (numbers !== null) {
            return numbers.join("");
        }
        return "";
    }
    function formatPhone(num) {
        const numeric_part = getPhoneNumber(num);
        const first_three = numeric_part.slice(0, 3);
        const second_three = numeric_part.slice(3, 6);
        const last_four = numeric_part.slice(6, 10);
        let final_form = "";
        if (first_three.length === 0) {
            final_form = "";
        }
        else if (first_three.length < 3) {
            final_form = `(${first_three}`;
        }
        else if (second_three.length === 0) {
            final_form = `(${first_three}`;
        }
        else if (second_three.length < 3) {
            final_form = `(${first_three})-${second_three}`;
        }
        else if (last_four.length === 0) {
            final_form = `(${first_three})-${second_three}`;
        }
        else {
            final_form = `(${first_three})-${second_three}-${last_four}`;
        }
        return final_form;
    }
    const verifyPhone = (value, name) => {
        const phone = formatPhone(value);
        onChange(phone, name);
    };
    return (_jsxs("div", { className: "my-profile__basics-container my-profile__basics", children: [_jsx(ProfileDataCardTitle, { title: "Account Details", editMode: editMode.details, setEdit: updateEditModeState, name: "details" }), _jsx("div", { className: "my-profile__items-wrapper", children: _jsxs("div", { className: styles.inputs_wrapper, children: [_jsx(ProfileBasicsDataCardItem, { className: styles.input_styles, type: "text", onInputChange: onChange, value: subscriberData.first_name || "", label: "First Name", name: "first_name", editMode: editMode.details, wrapperClassName: styles.name_input }), _jsx(ProfileBasicsDataCardItem, { className: styles.input_styles, type: "text", onInputChange: onChange, value: subscriberData.last_name || "", label: "Last Name", name: "last_name", editMode: editMode.details, wrapperClassName: styles.name_input }), _jsx(ProfileBasicsDataCardItem, { className: styles.input_styles, type: "email", onInputChange: onChange, value: subscriberData.email, label: "Email", name: "email", editMode: editMode.details, wrapperClassName: styles.full_width_input }), _jsxs("div", { className: styles.mobile_input_wrapper, children: [_jsx(ProfileBasicsDataCardItem, { className: styles.input_styles, type: "tel", onInputChange: verifyPhone, value: subscriberData.phone, label: "Mobile Number", name: "phone", editMode: editMode.details, wrapperClassName: styles.mobile_input, pattern: "\\(?\\d{3}\\)?-? *\\d{3}-? *-?\\d{4}" }), !changePassword && (_jsx(RoundedGainfulButton, { dataAttr: "change-password-button", onClick: () => setChangePassword(true), label: "Change Password" }))] }), changePassword && (_jsx(ChangePasswordBox, { closeBox: () => setChangePassword(false) }))] }) })] }));
};
export default AccountDetails;
